import React from "react";
import EdicionPermisos from "components/TableContainer/EdicionPermisos";

const Permisos = () => {
  return <EdicionPermisos />;
};

export default Permisos;